import { useEffect } from 'react';
import { PrivatePage } from '../../../components/private-page';
import { ctGameDefault, ctGameTitle } from '../../../constants/text';
import WstApprovalGrid from '../../../features/wst-approval-grid';

export default function WstApproval() {
  useEffect(() => {
    document.title = ctGameTitle + ' - WST Challenge Pending Approval';

    return () => {
      // return default value when component unmounts
      document.title = ctGameDefault;
    };
  }, []);

  return (
    <PrivatePage
      className={'page-base--full'}
      breadcrumb={[
        { label: 'Dashboard', href: 'dashboard' },
        { label: 'Administration', href: '../administration' },
        {
          label: 'WST Challenge Pending Approval',
          href: 'administration/wst/pending'
        }
      ]}
      pageTitle={'Administration'}>
      <WstApprovalGrid />
    </PrivatePage>
  );
}
